import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginSampleData } from "../usePluginSampleData"
import { TryAddOnItem } from "./TryAddOnItem"

export const TryAddOnItemOrthomosaic = () => {
    const plugin = usePluginSampleData(NovaPluginIds.Ortho)
    return <TryAddOnItem plugin={plugin} />
}
